/* Förstoringen på lampsidorna.

   Produktsidan har sin egen kopia inne i sektionen, hopvuxen med galleriet.
   Lampsidorna bygger galleriet i skriptet och behöver därför en förstoring som
   går att fylla i efterhand — men beteendet ska vara detsamma som på en
   produktsida: live helskärm, klick togglar ett zoomsteg, ×/Esc stänger,
   tryck zoomar på mobil och krysset snurrar innan det stänger.

   Klasserna kommer från produktsidans stilar, som redan ligger i temats
   gemensamma stilmall. */
(function () {
  var DESKTOP = '(min-width: 769px)';
  var ZOOM_DESKTOP = 1.8;
  var ZOOM_MOBILE = 2.4;
  var MJUK = 'transform 0.55s cubic-bezier(0.22, 1, 0.36, 1)';
  var CURSOR_PATHS = {
    plus: 'M7 2.5 V11.5 M2.5 7 H11.5',
    minus: 'M2.5 7 H11.5'
  };

  function skapa(dialog) {
    var scrollEl = dialog.querySelector('[data-lampbox-scroll]');
    var cursor = dialog.querySelector('[data-lampbox-cursor]');
    var cursorPath = cursor ? cursor.querySelector('path') : null;
    var stangEl = dialog.querySelector('[data-lampbox-close]');
    var captionEl = dialog.querySelector('[data-lampbox-caption]');
    var desktop = window.matchMedia(DESKTOP);
    var etiketter = [];
    var aktivIdx = 0;

    var nere = false;
    var flyttad = false;
    var harPanorera = false;
    var startX = 0;
    var startY = 0;

    var zo = {
      pa: false,
      bild: null,
      drar: false,
      tx: 0,
      ty: 0,
      bredd: 0,
      hojd: 0,
      scale: 1,
      sistX: 0,
      sistY: 0
    };

    function zoomSteg() {
      return desktop.matches ? ZOOM_DESKTOP : ZOOM_MOBILE;
    }

    function begransa(varde, tak) {
      if (varde > tak) return tak;
      if (varde < -tak) return -tak;
      return varde;
    }

    function setCursorIcon(mode) {
      if (!cursorPath || !CURSOR_PATHS[mode]) return;
      cursorPath.setAttribute('d', CURSOR_PATHS[mode]);
    }

    function syncCursor() {
      setCursorIcon(zo.pa ? 'minus' : 'plus');
    }

    function lagg(mjukt) {
      if (!zo.bild) return;
      zo.tx = begransa(zo.tx, zo.bredd * (zo.scale - 1) / 2);
      zo.ty = begransa(zo.ty, zo.hojd * (zo.scale - 1) / 2);
      zo.bild.style.transition = mjukt ? MJUK : 'none';
      zo.bild.style.transform = 'translate(' + zo.tx + 'px,' + zo.ty + 'px) scale(' + zo.scale + ')';
    }

    function nollstall() {
      if (zo.bild) {
        zo.bild.style.transition = MJUK;
        zo.bild.style.transform = '';
        zo.bild.classList.remove('is-zoomed');
      }
      zo.pa = false;
      zo.bild = null;
      zo.drar = false;
      zo.tx = 0;
      zo.ty = 0;
      zo.scale = 1;
      scrollEl.style.overflow = '';
      scrollEl.style.scrollSnapType = '';
      scrollEl.style.touchAction = '';
      syncCursor();
    }

    function hittaSlide(e) {
      var slide = e.target && e.target.closest ? e.target.closest('.tambur-lightbox__slide') : null;
      if (!slide && typeof document.elementFromPoint === 'function') {
        var hit = document.elementFromPoint(e.clientX, e.clientY);
        slide = hit && hit.closest ? hit.closest('.tambur-lightbox__slide') : null;
      }
      return slide;
    }

    function vaxla(e) {
      var slide = hittaSlide(e);
      if (!slide) return;
      var bild = slide.querySelector('.tambur-lightbox__image');
      if (!bild) return;
      if (zo.pa) {
        nollstall();
        return;
      }
      var ruta = bild.getBoundingClientRect();
      zo.pa = true;
      zo.bild = bild;
      zo.bredd = ruta.width;
      zo.hojd = ruta.height;
      zo.tx = 0;
      zo.ty = 0;
      zo.scale = zoomSteg();
      bild.style.transformOrigin =
        Math.min(100, Math.max(0, (e.clientX - ruta.left) / ruta.width * 100)) + '% ' +
        Math.min(100, Math.max(0, (e.clientY - ruta.top) / ruta.height * 100)) + '%';
      bild.classList.add('is-zoomed');
      scrollEl.style.overflow = 'hidden';
      scrollEl.style.scrollSnapType = 'none';
      scrollEl.style.touchAction = 'none';
      lagg(true);
      syncCursor();
    }

    function visaMarkor(pa) {
      if (!cursor) return;
      var visa = pa && desktop.matches;
      cursor.hidden = !visa;
      cursor.setAttribute('aria-hidden', visa ? 'false' : 'true');
      if (visa) syncCursor();
    }

    function flyttaMarkor(e) {
      if (!cursor || cursor.hidden) return;
      cursor.style.left = e.clientX + 'px';
      cursor.style.top = e.clientY + 'px';
    }

    function ritaCaption() {
      if (!captionEl) return;
      if (!etiketter.length) {
        captionEl.hidden = true;
        captionEl.textContent = '';
        return;
      }
      var t = etiketter[aktivIdx] || '';
      captionEl.hidden = !t;
      captionEl.textContent = t
        ? t + ' · ' + (aktivIdx + 1) + ' / ' + etiketter.length
        : '';
    }

    function syncAktivFranScroll() {
      if (!scrollEl.children.length) return;
      var mitt = scrollEl.scrollTop + scrollEl.clientHeight / 2;
      var i = 0;
      Array.prototype.forEach.call(scrollEl.children, function (c, n) {
        if (c.offsetTop <= mitt) i = n;
      });
      if (i !== aktivIdx) {
        aktivIdx = i;
        ritaCaption();
      }
    }

    function stang() {
      nollstall();
      if (captionEl) {
        captionEl.hidden = true;
        captionEl.textContent = '';
      }
      etiketter = [];
      aktivIdx = 0;
      if (typeof dialog.close === 'function') {
        dialog.close();
      } else {
        dialog.removeAttribute('open');
      }
    }

    dialog.addEventListener('close', function () {
      visaMarkor(false);
      document.body.style.overflow = '';
    });

    scrollEl.addEventListener('scroll', syncAktivFranScroll, { passive: true });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      stang();
    });

    dialog.addEventListener('pointermove', flyttaMarkor);

    dialog.addEventListener('pointerdown', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-lampbox-close]')) return;
      nere = true;
      flyttad = false;
      harPanorera = false;
      startX = e.clientX;
      startY = e.clientY;
      if (zo.pa) {
        zo.drar = true;
        zo.sistX = e.clientX;
        zo.sistY = e.clientY;
      }
    });

    dialog.addEventListener('pointermove', function (e) {
      if (!nere) return;
      if (Math.abs(e.clientX - startX) > 8 || Math.abs(e.clientY - startY) > 8) flyttad = true;
      if (zo.pa && zo.drar && zo.bild) {
        var dx = e.clientX - zo.sistX;
        var dy = e.clientY - zo.sistY;
        if (dx || dy) {
          zo.tx += dx;
          zo.ty += dy;
          zo.sistX = e.clientX;
          zo.sistY = e.clientY;
          if (flyttad) harPanorera = true;
          lagg(false);
        }
        e.preventDefault();
      }
    });

    dialog.addEventListener('pointerup', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-lampbox-close]')) {
        nere = false;
        flyttad = false;
        harPanorera = false;
        zo.drar = false;
        return;
      }
      zo.drar = false;
      if (nere && !flyttad && !harPanorera) vaxla(e);
      nere = false;
      flyttad = false;
      harPanorera = false;
    });

    /* Krysset snurrar ett kvarts varv och stänger först när det står stilla. */
    if (stangEl) {
      stangEl.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (stangEl.classList.contains('is-spinning')) return;
        var ikon = stangEl.querySelector('.tambur-lightbox__close-icon');
        var klar = false;
        function avsluta() {
          if (klar) return;
          klar = true;
          if (ikon) ikon.removeEventListener('animationend', avsluta);
          stangEl.classList.remove('is-spinning');
          stang();
        }
        stangEl.classList.add('is-spinning');
        if (ikon) {
          ikon.addEventListener('animationend', avsluta);
          setTimeout(avsluta, 500);
        } else {
          avsluta();
        }
      });
    }

    if (desktop.addEventListener) {
      desktop.addEventListener('change', function () {
        if (!desktop.matches) nollstall();
        visaMarkor(dialog.open);
      });
    }

    /* urler är bildernas adresser, sidbilder samma bilder som de ligger på
       sidan: deras proportioner behövs för att sliderna ska ha rätt höjd innan
       bilderna laddat, annars hamnar den klickade bilden utanför vyn.
       etiketter (valfritt): text per bild, t.ex. "I bilden: …" — visas nere till
       vänster och uppdateras när man scrollar. */
    return function oppna(urler, sidbilder, index, etikettLista) {
      if (!urler.length) return;
      var start = Math.max(0, Math.min(index || 0, urler.length - 1));
      scrollEl.innerHTML = '';
      nollstall();
      etiketter = Array.isArray(etikettLista) ? etikettLista.slice() : [];
      aktivIdx = start;

      urler.forEach(function (url, i) {
        var slide = document.createElement('div');
        slide.className = 'tambur-lightbox__slide';
        slide.setAttribute('data-slide-index', i);

        var ram = document.createElement('div');
        ram.className = 'tambur-lightbox__frame';

        var bild = document.createElement('img');
        bild.className = 'tambur-lightbox__image';
        bild.alt = '';
        bild.draggable = false;
        bild.src = bredd(url, 2400);
        bild.srcset = [1200, 1800, 2400, 3200]
          .map(function (b) { return bredd(url, b) + ' ' + b + 'w'; })
          .join(', ');
        bild.sizes = '100vw';

        var kalla = sidbilder && sidbilder[i];
        if (kalla && kalla.naturalWidth) {
          bild.style.aspectRatio = kalla.naturalWidth + ' / ' + kalla.naturalHeight;
        }

        ram.appendChild(bild);
        slide.appendChild(ram);
        scrollEl.appendChild(slide);
      });

      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.body.style.overflow = 'hidden';
      visaMarkor(true);
      ritaCaption();

      function till() {
        var mal = scrollEl.querySelector('[data-slide-index="' + start + '"]');
        if (mal) mal.scrollIntoView({ block: 'start' });
        aktivIdx = start;
        ritaCaption();
      }

      requestAnimationFrame(till);
      scrollEl.querySelectorAll('img').forEach(function (b) {
        if (!b.complete) b.addEventListener('load', till, { once: true });
      });
    };
  }

  function bredd(url, px) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + px;
  }

  window.TamburLampbox = {
    koppla: function (dialog) {
      if (!dialog) return function () {};
      if (!dialog.tamburOppna) dialog.tamburOppna = skapa(dialog);
      return dialog.tamburOppna;
    }
  };
})();
